import ProductAuthorContent from "./product-author-content";

export default ProductAuthorContent;